export default __webpack_public_path__ + "static/menu-shop-interior-e9f931bbecf707418a0e6ade896c6e02.jpeg";